import { ServerDate } from "@/helpers/server-date.class"
import { api } from "@/store/api"
import { IServerTimeResponse } from "@/store/apis/serverTimeAPI/server-time.types"

export const serverTimeAPI = api.injectEndpoints({
  endpoints: (build) => ({
    fetchServerTime: build.query<IServerTimeResponse, void>({
      query: () => ({ url: "/time", method: "GET" }),
      keepUnusedDataFor: Infinity,
      transformResponse: (response: IServerTimeResponse) => {
        if (!ServerDate.isSet()) {
          ServerDate.setGap(response.timestamp - Date.now())
        }
        return response
      }
    })
  })
})

export const { useFetchServerTimeQuery } = serverTimeAPI
